import './tutorialPage.css';
import pause from './gifs/pause.gif';
import login from './gifs/login.gif';
import select from './gifs/select.gif';
import resume from './gifs/resume.gif';
import popup from './gifs/popup.gif';
import TutorialGif from '../../components/tutorialgif/tutorialgif';
import logo from '../../assets/images/selectext-logo-filled.svg'
import VideoDemo from '../../components/videoDemo/videoDemo';
import { TextareaAutosize, Button } from '@material-ui/core';
import { Element, scroller } from 'react-scroll';
import config from '../../config';
import * as qs from 'qs';
import { useLocation } from 'react-router-dom';
import TopNavBar from '../../components/topNavBar/topNavBar';
import TopBanner from '../../components/topBanner/topBanner';


const TutorialPage = () => {
    const location = useLocation();
    const showNav = qs.parse(location.search, { ignoreQueryPrefix: true }).n !== undefined;
    return (
        <>
        {showNav && <><TopNavBar /><TopBanner /></>}

        <div className="tutorialPageWrapper">
            <img className={"logoHeaderSmall"} alt={"Selectext logo"} style={{display: showNav ? 'none' : 'block' }} src={logo} />
            <h1 className="tutmainheader">How to use Selectext</h1>
            <p className='followStepsBelow'>Follow the steps below to get started. Or...</p>
            <Button className="tryitnowButton" onClick={() => scroller.scrollTo("tryout", { smooth: true })}>Try it now!</Button>
            <TutorialGif gif={pause} name="pause" header="1. Pause the video and click the toggle in the top left" desc="The toggle will not show up until the video is paused." />
            <TutorialGif gif={login} name="login" header="2. Login in with Google" desc="You will only have to do this the first time you use Selectext. If clicking the log in with Google button does not work, you can manually go to https://selectext.app/login in a new tab to log in, then resume the video, pause it again, then click the toggle." />
            <TutorialGif gif={select} name="select" header="3. Click and drag while holding the mouse down to select and copy the text" desc="The text will automatically get copied to your clipboard. Paste the text as normal using ctrl+v (windows) or cmd+v (mac)." />
            <TutorialGif gif={resume} name="resume" header="4. Once you're done selecting, resume the video by clicking play in the control bar" desc="You can also use the space bar as you normally would, or you can switch off the toggle then click the main video area as normal." />
            <TutorialGif gif={popup} name="popup" header="5. Click the extension icon in the top right to access the settings and to track your credits" desc={`You get ${config.freePlanInfo.credits} credits per month on the free plan. You can upgrade to get more credits via the extension popup in the top right. You can also stop the toggle showing up on a the current site, and change the settings.`} />

            <div className='tryoutstart'><Element name="tryout"><h1 className="tryoutheader">Try the steps on the video below</h1></Element></div>
            <p className="tryoutdesc">Once you have selected the text, you can paste it in the text area underneath the video.</p>
            <VideoDemo url="https://vimeo.com/520928742" />
            <TextareaAutosize
                minRows={10}
                placeholder="Paste the text here"
                className='tuttextarea'
            />

            <div className='byebyewrapper'>
                <h1 className='byebyetext'>Now go and try Selectext on some other videos!</h1>
                <p className='byebyesmalltext'>If you love it, we would really appreciate a review.</ p>
                <p className='byebyesmalltext'>If you can't get it working, leave a comment in the 'support' section on the extension in the Chrome Web Store and we will try our best to help you out.</ p>
            </div>
        </div >
        </>
    )
}

export default TutorialPage